import { combineReducers } from "redux"
import calenderReducer from "./calendar/"
import emailReducer from "./email/"
import chatReducer from "./chat/"
import todoReducer from "./todo/"
import customizer from "./customizer/"
import auth from "./auth/"
import navbar from "./navbar/Index"
import dataList from "./data-list/"
import dataListNew from "./data-list-new/"
import userReducer from './user'
import notificationReducer from "./notifications"
import appStateReducer from "./appState"

const rootReducer = combineReducers({
  calendar: calenderReducer,
  emailApp: emailReducer,
  todoApp: todoReducer,
  chatApp: chatReducer,
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  dataList: dataList,
  dataListNew:dataListNew,
  user: userReducer,
  notification:notificationReducer,
  appState: appStateReducer
})

export default rootReducer
